module.exports = __webpack_public_path__ + "img/chatJangProfile.7091b61.png";